import { GeospatialList } from "@/components/project/ProjectDataSheet/GeospatialList"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_private/projects/$id/data/geospatial/",
)({
  component: GeospatialRoute,
})

function GeospatialRoute() {
  const navigate = Route.useNavigate()
  const { id } = Route.useParams()
  return (
    <GeospatialList
      onBack={() => navigate({ to: "/projects/$id/data", params: { id } })}
    />
  )
}
